import '@/components/hero-slide/hero-slide'
import '@/components/image/image'
import HeroSlider from '@/components/hero-slider/hero-slider'
HeroSlider.initialize();